<div class="filter-in-view-component-container" [ngClass]="cssClass">
  <section class="filter-in-view-label-container">
    @if (!filterInline) {
      <section-label
        class="section-label"
        [sectionLabelContent]="filterSectionLabel"
      ></section-label>
    }
    @if (filterInline) {
      <div>
        <span class="data-label-inline font-size-12px filter-by-label"
          >Filter By:</span
          >
        </div>
      }
    </section>
    <section class="filter-in-view-options-container">
      <!-- Filter Menu & submenu nested -->
      @if (showDateRanges) {
        <div class="due-date-range-container">
          <mat-form-field appearance="outline" class="due-date-range-field">
            <mat-label> Due Date </mat-label>
            <input
              class="due-date-range-field-input"
              [ngClass]="dueDateStatus"
              matInput
              placeholder="Due Date"
              autocomplete="off"
              readonly
              [(ngModel)]="dateRangeFormatted"
              [matMenuTriggerFor]="dateRange"
              (change)="onDateInputChanged($event)"
              />
            <span matPrefix [matMenuTriggerFor]="dateRange"
              ><mat-icon
              class="due-date-range-icon"
              [svgIcon]="'calendar_icon'"
              [matMenuTriggerFor]="dateRange"
              ></mat-icon
            ></span>
            <mat-menu
              #dateRange="matMenu"
              role="dialog"
              class="date-ranges-mat-menu"
              >
              <ng-template matMenuContent>
                <date-ranges-filter-menu
                  [classStartDate]="classStartDate"
                  [savedDateRanges]="savedDateRanges"
                  [userData]="userData"
                  [dueDateStatus]="dueDateStatus"
                  (sendDateRanges)="getDateRanges($event)"
                  (click)="$event.stopPropagation()"
                ></date-ranges-filter-menu>
              </ng-template>
            </mat-menu>
          </mat-form-field>
        </div>
      }
      @for (filterColumn of filterColumns(); track filterColumn) {
        <mat-form-field appearance="outline" [class]="filterColumn">
          <mat-label>
            {{ apiColumnToDisplayName(filterColumn) }}
          </mat-label>
          <mat-select
            [disabled]="loading"
            [formControl]="filterForm.get(filterColumn)"
            (openedChange)="filterChanged($event, filterColumn)"
            (selectionChange)="selectionChanged($event, filterColumn)"
            multiple
            >
            @for (filterOpt of filterColumnOpts(filterColumn); track filterOpt) {
              <mat-option
                [value]="filterOpt"
                >
                @if (hasIcon(filterColumn)) {
                  <img
                    class="assignment-pill-icon mat-icon"
                    [src]="getIconPath(filterOpt)"
                    />
                }
                {{ apiColumnOptToDisplayName(filterColumn, filterOpt) }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </section>
  </div>
